(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@normy/query-core"), require("@normy/core"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["@normy/query-core", "@normy/core", "react"], factory);
	else if(typeof exports === 'object')
		exports["NormyReactQuery"] = factory(require("@normy/query-core"), require("@normy/core"), require("react"));
	else
		root["NormyReactQuery"] = factory(root["NormyQueryCore"], root["Normy"], root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__normy_query_core__, __WEBPACK_EXTERNAL_MODULE__normy_core__, __WEBPACK_EXTERNAL_MODULE_react__) => {
return 